import React, { Fragment } from 'react';

const Dashboard = () => {
    return (<p>Client Dashboard</p>);
};

export default Dashboard;